import React from "react";
import appConfig from "configs/app.config";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "utils/hooks/useAuth";
import { getUrlAuthToken } from "utils/authToken";

const { unAuthenticatedEntryPath } = appConfig;

const ProtectedRoute = () => {
  const location = useLocation();
  const { state } = location;
  console.log("state <><><><><>:", state);

  const { authenticated } = useAuth();
  const urlToken = getUrlAuthToken();

  // Allow app deep-link with ?token= so profile can run silent auth bootstrap
  if (!authenticated && !urlToken) {
    return <Navigate to={`${unAuthenticatedEntryPath}`} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
